import React from "react"
import { apiBaseURI } from "../../config"

export const BoardMemberItem = ({ name, image, designation }) => {
    return (
        <div className="ef-board-member-item mb-8">
            <div className="flex justify-center">
                <img
                    src={`${apiBaseURI}${image}`}
                    className="rounded-full w-1/2"
                    alt={name}
                />
            </div>
            <div className="text-center text-white mt-4">
                <h3 className="font-bold text-2xl lg:text-3xl">{name}</h3>
                <h4 className="font-bold text-lg lg:text-xl">{designation}</h4>
            </div>
        </div>
    )
}
